<template>
<div class="main">
	<div class="title">投保企业信息</div>
	<Form :label-width="140" class="mt15 info" >
		<Row>
			<Col span="8">
				<FormItem label="公司名称：">{{companyInfo.companyName}}</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="统一社会信用代码：">{{companyInfo.organizationCode}}</FormItem>
			</Col>
		</Row>
		<Row>
			<Col span="8">
				<FormItem label="联系人：">{{companyInfo.contactsName}}</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="联系电话：">{{companyInfo.contactsPhone}}</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="联系人邮箱：">{{companyInfo.contactsEmail}}</FormItem>
			</Col>
		</Row>
	</Form>
	<div class="title">保障计划</div>
	<Form :label-width="140" class="mt15 info" >
		<Row>
			<Col span="8">
				<FormItem label="保障期限：">{{companyInfo.insuredPeriodName}}</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障起期：">{{companyInfo.effectiveDateStart}}</FormItem>
			</Col>
			<Col span="8">
				<FormItem label="保障止期：">{{companyInfo.effectiveDateEnd}}</FormItem>
			</Col>
			<Col span="24">
				<FormItem label="附加险：" v-if="companyInfo.subjoinAllDay||companyInfo.subjoinOwnMedicine||companyInfo.subjoinProportionAdj">
					<p v-if="companyInfo.subjoinAllDay">附加24小时意外 基础方案价格*110%</p>
					<p v-if="companyInfo.subjoinOwnMedicine">附加自费药补偿 基础方案价格*115%</p>
					<p v-if="companyInfo.subjoinProportionAdj">附加伤残赔偿比例调整  基础方案价格*110%</p>
				</FormItem>
			</Col>
		</Row>
	</Form>
	<Table :columns="columns" border :data="schemeList"></Table>
	<div class="download-btn mt15">
		<UploadFile	
			style="display:inline-block"
			url="/pc/employerLiability/importEmployeeApp"
			:show-upload-list="false"
			:data="{count:policyIdNum,address:id,insuranceCompanyCode:'GUO_SHOU_CAI'}"
			btn-text="上传人员明细"
			@on-success="uploadSuccess" />
		<span class="downloadFile">
			请根据模板整理人员名单上传，
			<a @click="download">点击下载模板</a>
		</span>
	</div>
	<Table 
		:columns="personListColumns" 
		:data="personList"
		class="mt10"
		border
		v-if="personList.length>0"
		disabled-hover>
		<template slot-scope="{ row, index }" slot="msg">
			<span :style="{color:row.success?'green':'red'}">{{row.msg}}</span>
		</template>
	</Table>
	<div class="mt20 center">
		<p class="mt10">
			<Button type="primary" @click="sub" :disabled="disabled" :loading="loading">确认上传</Button>
		</p>
	</div>
</div>
</template>
<script>
import UploadFile from '../common/UploadFile'
export default {
	components:{ UploadFile },
	data () {
		return {
			policyId:this.$route.params.policyId,
			id:this.$route.params.id,
			policyIdNum:'',
			schemeList:[],
			companyInfo:{},
			columns:[
				{title: '序号',type: 'index',width:70,align:'center'},
				{title: '工种',key: 'workTypeName',minWidth:150},
				{title: '保障方案',key: 'insurancePlanName',minWidth:280},
				{title: '人数',key: 'count',width:100},
			],
			loading:false,
			id:this.$route.params.id,
			personListColumns:[
				{title: '校验结果',slot: 'msg',width:200},
                {title: '序号',type: 'index',width:70,align:'center'},
				{title: '工种',key: 'workType',width:150},
				{title: '保障方案',key: 'insurancePlan',minWidth:280},
                {title: '姓名',key: 'name',width:120},
				{title: '身份证号',key: 'certificateNumber',width:190},
			],
			personList:[],
		}
	},
	computed:{
		disabled(){
			let pass=true;
			this.personList.forEach(item=>{
				if(!item.success){
					pass=false
				}
			})
			return !pass||this.personList.length==0
		}
	},
	created () {
		if(this.policyId&&this.id){
			this.getInfo()
		}
	},
	methods:{
		// 根据id获取信息
		getInfo(){
			this.$axios.post('/employerLiability/getCacheDetailInfo.json',{
				value:this.policyId
			}).then(res=>{
				this.policyIdNum=res.count;
				this.companyInfo=res.data||{};
				if(res.employerTotalAmountVO&&res.employerTotalAmountVO.employerAmountVO){
					this.schemeList=res.employerTotalAmountVO.employerAmountVO;
					this.companyInfo.subjoinAllDay=res.employerTotalAmountVO.employerAmountVO[0].subjoinAllDay
					this.companyInfo.subjoinOwnMedicine=res.employerTotalAmountVO.employerAmountVO[0].subjoinOwnMedicine
					this.companyInfo.subjoinProportionAdj=res.employerTotalAmountVO.employerAmountVO[0].subjoinProportionAdj
				}
			});
		},
		// 校验
		async sub () {
			this.confirm('确定上传人员？',()=>{
				this.loading = true;
				
				this.$axios.post('/employerLiability/cacheOrConfirmEmployee.json.all',{
					policyId:this.policyId,
					address:this.id
				}).then(res=>{
					this.loading = false;
					if(res.code==10000000){
						this.$router.replace('/company-group-employer/fillin-person-success');
					}else{
						this.alert(res.msg)
					}
				});
			})
		},
		/*上传成功后获取数据*/
		uploadSuccess (res) {
			this.personList = res.data;
		},
		// 下载模板
		download() {
			// this.policyIdNum就是未加密的policyId
			this.exportToExcel('/employerLiability/exportExcelTemplate',{uuid:this.policyIdNum})
		},
	}
}
</script>
<style scoped>
	.main{
		margin-top: 15px;
		padding :30px 40px;
	}
	.downloadFile{
		font-size: 14px;
		margin-left: 20px;
		margin-right: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/haierProduct/components/companyGroupEmployerGS/FillinPerson.vue